/* SBS page runtime: renders the site's page templates ({{bindings}}, <sc-for>, <sc-if>)
   and keeps the DOM in sync on setState without wiping typed input. */
(function () {
  'use strict';
  var IMG = window.SBS_IMG || {};
  function fixUrls(s) {
    if (typeof s !== 'string' || s.indexOf('/_blob/') < 0) return s;
    return s.replace(/\/_blob\/([0-9a-f]{32})/g, function (m, id) { return IMG[id] || m; });
  }
  function lookup(path, scopes) {
    var parts = path.trim().split('.');
    for (var i = scopes.length - 1; i >= 0; i--) {
      var sc = scopes[i];
      if (sc && Object.prototype.hasOwnProperty.call(sc, parts[0])) {
        var v = sc[parts[0]];
        for (var j = 1; j < parts.length; j++) { if (v == null) return undefined; v = v[parts[j]]; }
        return v;
      }
    }
    return undefined;
  }
  var ONE = /^\{\{\s*([\w$.]+)\s*\}\}$/;
  function interp(str, scopes) {
    return str.replace(/\{\{\s*([\w$.]+)\s*\}\}/g, function (m, p) {
      var v = lookup(p, scopes);
      return v == null ? '' : String(v);
    });
  }
  function truthy(v) { return !(v === false || v === 'false' || v == null || v === '' || v === 0); }

  // Build a plain virtual tree from the template DOM for the current scopes.
  function build(node, scopes, out) {
    if (node.nodeType === 3) {
      var t = node.nodeValue;
      out.push({ t: '#text', v: t.indexOf('{{') >= 0 ? interp(t, scopes) : t });
      return;
    }
    if (node.nodeType !== 1) return;
    var tag = node.tagName.toLowerCase();
    if (tag === 'sc-for') {
      var lm = ONE.exec(node.getAttribute('list') || '');
      var list = lm ? lookup(lm[1], scopes) : null;
      var as = node.getAttribute('as') || 'item';
      if (Array.isArray(list)) {
        for (var i = 0; i < list.length; i++) {
          var sc = {}; sc[as] = list[i]; sc[as + 'Index'] = i;
          var ns = scopes.concat([sc]);
          for (var c = node.firstChild; c; c = c.nextSibling) build(c, ns, out);
        }
      }
      return;
    }
    if (tag === 'sc-if') {
      var vm = ONE.exec(node.getAttribute('value') || '');
      var val = vm ? lookup(vm[1], scopes) : node.getAttribute('value');
      if (truthy(val)) for (var c2 = node.firstChild; c2; c2 = c2.nextSibling) build(c2, scopes, out);
      return;
    }
    if (tag === 'helmet') return;
    var el = { t: tag, a: {}, on: {}, k: [] };
    for (var a = 0; a < node.attributes.length; a++) {
      var at = node.attributes[a], name = at.name, raw = at.value;
      if (name.indexOf('hint-') === 0) continue;
      if (/^on[a-z]+$/i.test(name)) {
        var fm = ONE.exec(raw);
        var fn = fm ? lookup(fm[1], scopes) : null;
        if (typeof fn === 'function') el.on[name.slice(2).toLowerCase()] = fn;
        continue;
      }
      var v2 = raw.indexOf('{{') >= 0 ? interp(raw, scopes) : raw;
      el.a[name] = fixUrls(v2);
    }
    var kids = node.content ? node.content : node;
    for (var k = kids.firstChild; k; k = k.nextSibling) build(k, scopes, el.k);
    out.push(el);
  }

  var SVG = 'http://www.w3.org/2000/svg';
  function create(v, inSvg) {
    if (v.t === '#text') return document.createTextNode(v.v);
    var svg = inSvg || v.t === 'svg';
    var el = svg ? document.createElementNS(SVG, v.t) : document.createElement(v.t);
    for (var n in v.a) { try { el.setAttribute(n, v.a[n]); } catch (e) {} }
    el._sbsOn = v.on;
    for (var i = 0; i < v.k.length; i++) el.appendChild(create(v.k[i], svg && v.t !== 'foreignobject'));
    return el;
  }
  function patchAttrs(el, v) {
    var old = el.attributes;
    for (var i = old.length - 1; i >= 0; i--) { var n = old[i].name; if (!(n in v.a)) el.removeAttribute(n); }
    for (var k in v.a) { if (el.getAttribute(k) !== v.a[k]) { try { el.setAttribute(k, v.a[k]); } catch (e) {} } }
    el._sbsOn = v.on;
  }
  function patchKids(parent, vkids, inSvg) {
    var cur = parent.firstChild, i = 0;
    for (; i < vkids.length; i++) {
      var v = vkids[i];
      if (!cur) { parent.appendChild(create(v, inSvg)); continue; }
      var next = cur.nextSibling;
      if (v.t === '#text') {
        if (cur.nodeType === 3) { if (cur.nodeValue !== v.v) cur.nodeValue = v.v; }
        else parent.replaceChild(create(v, inSvg), cur);
      } else if (cur.nodeType === 1 && cur.tagName.toLowerCase() === v.t) {
        patchAttrs(cur, v);
        patchKids(cur, v.k, inSvg || v.t === 'svg');
      } else {
        parent.replaceChild(create(v, inSvg), cur);
      }
      cur = next;
    }
    while (cur) { var nx = cur.nextSibling; parent.removeChild(cur); cur = nx; }
  }
  // One delegated listener per event type reads the current handler off the element.
  var EVENTS = ['click', 'submit', 'input', 'change', 'keydown', 'mouseenter', 'mouseleave', 'focus', 'blur'];
  function delegate(root) {
    EVENTS.forEach(function (type) {
      root.addEventListener(type, function (e) {
        var n = e.target;
        while (n && n !== root.parentNode) {
          if (n._sbsOn && n._sbsOn[type]) {
            if (type === 'submit') e.preventDefault();
            if (type === 'click' && n.tagName === 'A' && (n.getAttribute('href') || '#') === '#') e.preventDefault();
            n._sbsOn[type].call(null, e);
            if (type !== 'mouseenter' && type !== 'mouseleave') return;
          }
          n = n.parentNode;
        }
      }, type === 'focus' || type === 'blur' || type === 'mouseenter' || type === 'mouseleave');
    });
  }

  function DCLogic(props) { this.props = props || {}; this.state = {}; }
  DCLogic.prototype.setState = function (patch) {
    var p = typeof patch === 'function' ? patch(this.state, this.props) : patch;
    for (var k in p) this.state[k] = p[k];
    if (this.__schedule) this.__schedule();
  };
  window.DCLogic = DCLogic;

  window.SBSMount = function (opts) {
    var tpl = document.getElementById(opts.template);
    var root = document.getElementById(opts.root);
    var frag = tpl.content;
    var helmet = frag.querySelector('helmet');
    if (helmet) Array.prototype.slice.call(helmet.children).forEach(function (n) {
      var c = n.cloneNode(true);
      if (c.tagName === 'STYLE') c.textContent = fixUrls(c.textContent);
      document.head.appendChild(c);
    });
    var xdc = frag.querySelector('x-dc') || frag;
    var props = {};
    var dp = opts.props || {};
    for (var k in dp) if (k.charAt(0) !== '$' && dp[k] && 'default' in dp[k]) props[k] = dp[k].default;
    var comp = new opts.Component(props);
    var pending = false;
    function render() {
      pending = false;
      var vals;
      try { vals = comp.renderVals(); } catch (e) { console.error('[SBS] render failed', e); return; }
      var out = [];
      for (var c = xdc.firstChild; c; c = c.nextSibling) build(c, [vals], out);
      patchKids(root, out, false);
    }
    comp.__schedule = function () { if (!pending) { pending = true; requestAnimationFrame(render); } };
    delegate(root);
    render();
    window.SBS_COMPONENT = comp;
    return comp;
  };

  // Cart helper shared by every page.
  window.SBSCart = {
    add: function (items, btn) {
      items = (items || []).filter(function (i) { return i && i.id; });
      if (!items.length) { alert('Sorry, that option is not available online yet. Call 507-210-5902 and we will set it up for you.'); return Promise.resolve(); }
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function (e) {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; }
          alert(e.message + '. Please call 507-210-5902 and we will help you place the order.');
        });
    },
    product: function (handle) { return (window.SBS_PRODUCTS || {})[handle] || null; },
    // Pick a variant by option NAME. req: must match; prefer: try these values in order, else any.
    pick: function (product, req, prefer) {
      if (!product || !product.variants) return null;
      var names = (product.options || []).map(function (o) { return (typeof o === 'string' ? o : o.name).toLowerCase(); });
      function val(v, name) { var i = names.indexOf(String(name).toLowerCase()); return i < 0 ? null : String(v['option' + (i + 1)] || '').toLowerCase(); }
      var list = product.variants.filter(function (v) {
        for (var k in (req || {})) { if (req[k] != null && val(v, k) !== String(req[k]).toLowerCase()) return false; }
        return v.available !== false || true;
      });
      if (!list.length) return null;
      var best = list[0], bestScore = -1;
      list.forEach(function (v) {
        var score = 0;
        for (var k in (prefer || {})) {
          var want = [].concat(prefer[k]).map(function (x) { return String(x).toLowerCase(); });
          var have = val(v, k), at = want.indexOf(have);
          if (at >= 0) score += 100 - at; else if (have === 'custom') score += 1;
        }
        if (score > bestScore) { bestScore = score; best = v; }
      });
      return best;
    },
    // "Heading: picked option" for every option group on the page, for the order notes.
    summary: function (root) {
      var props = {};
      (root || document).querySelectorAll('h2, h3').forEach(function (h) {
        var box = h.parentElement; if (!box) return;
        var picked = box.querySelectorAll('[aria-pressed="true"]');
        if (!picked.length) return;
        var label = h.textContent.replace(/\s*:.*$/, '').replace(/^\s*[\w]+\s·\s/, '').trim();
        var vals = [];
        picked.forEach(function (b) {
          var t = (b.getAttribute('aria-label') || b.getAttribute('title') || b.textContent || '').replace(/\s*·\s*[+$].*$/, '').replace(/\s+/g, ' ').trim();
          if (t && vals.indexOf(t) < 0) vals.push(t);
        });
        if (label && vals.length && label.length < 60) props[label] = vals.join(', ');
      });
      var notes = (root || document).querySelector('textarea');
      if (notes && notes.value.trim()) props['Special instructions'] = notes.value.trim();
      return props;
    },
    // Pick the variant of a product (Liquid-embedded JSON) whose options match.
    variant: function (product, opts) {
      if (!product || !product.variants) return null;
      var want = (opts || []).map(function (o) { return o == null ? null : String(o).trim().toLowerCase(); });
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = true;
        for (var j = 0; j < want.length; j++) {
          if (want[j] == null) continue;
          var have = String(v['option' + (j + 1)] || '').trim().toLowerCase();
          if (have !== want[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }
  };
})();
